import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../base/dtos/base-search.dto';
import { FileDto } from '../../files/dtos/file.dto';
import { UserStatusEnum } from '../enums/user-status.enum';
import { UserTypeEnum } from '../enums/user-type.enum';

/**
 * User DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.USER)
export class UserSearchDto extends BaseSearchDto {
	username!: string;
	email!: string;
	status!: UserStatusEnum;
	type!: UserTypeEnum;
	files?: FileDto[];

	displayValue(): string {
		return `${this.username}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string {
		return `${this.status}`;
	}
}
